import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ActivityLogData } from 'src/app/interfaces/activity.interface';
import { FileDescriptorBase } from 'src/app/swagger-api';

@Directive()
export abstract class ActivitiesBaseComponent {
  @Input({ required: true }) public activeUserId: string;
  @Input({ required: true }) public data: ActivityLogData;

  @Input({ required: false }) public isDialog = false;

  @Output() public submit: EventEmitter<void> = new EventEmitter<void>();
  @Output() public displayPopup: EventEmitter<FileDescriptorBase> = new EventEmitter<FileDescriptorBase>();

  public onDisplayPopup(value: FileDescriptorBase): void {
    this.displayPopup.emit(value);
  }

  public onSubmit(): void {
    this.submit.emit();
  }
}
